// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Styles
import './priority-submit-button.scss';

export default class PrioritySubmitButton extends Component {
    getClass() {
        const {className} = this.props;

        return classnames(
            {
                button: true,
                'priority-submit-button': true,
            },
            className
        );
    }

    getProps() {
        const {onSubmit} = this.props;
        const {disabled} = this.props;

        return {
            className: this.getClass(),
            disabled,
            onClick: onSubmit,
            type: 'submit',
        };
    }

    handleClick = (event) => {
        const {onSubmit} = this.props;
        onSubmit(event);
    };

    render() {
        const {label = 'Submit Priority'} = this.props;

        return <button {...this.getProps()}>{label}</button>;
    }
}

PrioritySubmitButton.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    onClick: PropTypes.func,
    onSubmit: PropTypes.func,
};
